import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Alert from '@/components/v1/Alert';
import NoteList from '@/components/v1/Notes/NoteList';

export default function Backend() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showCreatedAlert, setShowCreatedAlert] = useState(false);
  const [showUpdatedAlert, setShowUpdatedAlert] = useState(false);
  const [showDeletedAlert, setShowDeletedAlert] = useState(false);

  useEffect(() => {
    if (location.state?.noteCreated) {
      setShowCreatedAlert(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.noteCreated, location.pathname, navigate]);

  useEffect(() => {
    if (location.state?.noteUpdated) {
      setShowUpdatedAlert(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.noteUpdated, location.pathname, navigate]);

  useEffect(() => {
    if (location.state?.noteDeleted) {
      setShowDeletedAlert(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.noteDeleted, location.pathname, navigate]);

  return (
    <div className="bg-gray-900 min-h-screen w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
        >
          {showCreatedAlert && (
            <Alert
              message="New note created successfully."
              onDismiss={() => setShowCreatedAlert(false)}
            />
          )}
          {showUpdatedAlert && (
            <Alert
              message="Note updated successfully."
              onDismiss={() => setShowUpdatedAlert(false)}
            />
          )}
          {showDeletedAlert && (
            <Alert
              message="Note deleted successfully."
              onDismiss={() => setShowDeletedAlert(false)}
            />
          )}
          <div className="flex flex-wrap items-center justify-between gap-4">
            <h1 className="text-4xl md:text-5xl font-bold text-white">
              Backend
            </h1>
            <Link
              to="/backend/notes"
              className="inline-flex items-center justify-center rounded-md font-medium bg-indigo-600 hover:bg-indigo-700 text-white shadow-sm px-4 py-2 transition-colors focus:outline-none"
            >
              Create Note
            </Link>
          </div>
          <NoteList />
        </motion.div>
      </div>
    </div>
  );
}
